export default __webpack_public_path__ + "454084585669c554b85eafd80ccf34f6.svg";